export default Object.freeze({
    FUND: 'fund',
    HOLD: 'hold',
    RECOMMEND: 'recommend',
    INFO: 'info',
    REPORT: 'report',
});
